import axios from 'axios'
import { CONFIG } from '../config'
import { format } from 'date-fns'

export const axiosInstance = axios.create({
  baseURL: CONFIG.apiUrl,
})

axiosInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axiosInstance.defaults.withCredentials = true;
axiosInstance.interceptors.response.use(response => response, error => {
    return new Promise((resolve, reject) => {
        try {
            let csrfRequestUrl = '/api/csrf'
            console.log(error);
            if (
                error
                && error.response
                && error.response.status === 401
            ) {
                console.log(CONFIG.loginUrl)
                location.href = CONFIG.loginUrl
                return
            }

            if (
                error
                && error.response
                && error.response.status === 419
                && error.config.url !== csrfRequestUrl
                && !error.config.retried
            ) {
                axiosInstance.get(csrfRequestUrl).then(response => {
                    if (response.data.token) {
                        axiosInstance.defaults.headers.common['X-CSRF-TOKEN'] = response.data.token
                        error.config.headers['X-CSRF-TOKEN'] = response.data.token
                        error.config.retried = true
                        axiosInstance.request(error.config).then(resolve).catch(reject)
                        return
                    }
                    reject(error)
                }).catch(() => reject(error))
            } else {
                reject(error)
            }
        } catch (e) {
            return reject(error)
        }
    })
});
const Api = {
  getOrders: (date) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('orders?date=' + date)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('getOrders ERROR', error.response.data)
          resolve([])
        })
    })
  },
  completeOrder: (orderId) => {
    return new Promise((resolve) => {
      axiosInstance
        .post(`orders/${orderId}/complete`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('completeOrder ERROR', error.response.data)
          resolve([])
        })
    })
  },
  uncompleteOrder: (orderId) => {
    return new Promise((resolve) => {
      axiosInstance
        .post(`orders/${orderId}/uncomplete`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('uncompleteOrder ERROR', error.response.data)
          resolve([])
        })
    })
  },
  updateOrderStatus: (orderId, status, changeCashRegisterSend) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`orders/${orderId}/status`, {
            status: status,
            changeCashRegisterSend: changeCashRegisterSend,
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('order status update ERROR', error.response.data)
          resolve([])
        })
    })
  },
  getOrderCount: (dates) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('orders/count', {
          params: {
            dates: dates.map((date) => date.date),
          },
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('getOrdersCount ERROR', error.response.data)
          resolve([])
        })
    })
  },
  updateOrder: (order) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`orders/${order.id}`, order)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('updateOrder ERROR', error.response.data)
          resolve([])
        })
    })
  },
  updateLocation: (location) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`locations/${location.id}`, location)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getLocations: () => {
    return new Promise((resolve) => {
      axiosInstance
        .get('locations')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getMenu: () => {
    return new Promise((resolve) => {
      axiosInstance
        .get('menu/waiter')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getOrdersByRange: (dates: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('orders', {params: {
            dates: {
                start: format(dates[0], 'yyyy-MM-dd'),
                end: format(dates[1], 'yyyy-MM-dd'),
            }
        }})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  createOrder: (order: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .post('kitchen/order', order)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  updateOrderNotify: (order: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`orders/${order.id}/notify`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  orderDrinksStart: (order: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`orders/${order.id}/drinks-start`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  deleteOrder: (order) => {
    return new Promise((resolve) => {
      axiosInstance
        .delete(`orders/${order.id}`, order)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('updateOrder ERROR', error.response.data)
          resolve([])
        })
    })
  },
  createReservation: (reservation: any) => {
    return new Promise((resolve) => {
      const data = reservation;
      if (typeof reservation.date === 'object') {
        data.date = format(reservation.date, 'yyyy-MM-dd')
      }
      axiosInstance
        .post('kitchen/reservation', data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getReservationsCount: (dates) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations/count', {
          params: {
            dates: dates.map((date) => date.date),
          },
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('getReservationCount ERROR', error.response.data)
          resolve([])
        })
    })
  },
  getReservations: (date) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations?date=' + date)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('getReservations ERROR', error.response.data)
          resolve([])
        })
    })
  },
  getReservationsByRange: (dates: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations', {
          params: {
            dates: {
              start: format(dates[0], 'yyyy-MM-dd'),
              end: format(dates[1], 'yyyy-MM-dd'),
            }
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  deleteReservation: (id) => {
    return new Promise((resolve) => {
      axiosInstance
        .delete(`kitchen/reservations/${id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('deleteReservation ERROR', error.response.data)
          resolve([])
        })
    })
  },
  getAllReservations: (dates: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations/all', {
          params: {
            dates: {
              start: format(dates[0], 'yyyy-MM-dd'),
              end: format(dates[1], 'yyyy-MM-dd'),
            }
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getCalendarReservations: (dates: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations/calendar')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getPendingAction: () => {
    return new Promise(resolve => {
      axiosInstance.get('actions').then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.log('actions ERROR', error.response.data);
        resolve([])
      })
    })
  },
  saveAction: (id, actions) => {
    return new Promise(resolve => {
      axiosInstance.post('actions', {
        id,
        actions
      }).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.log('actions ERROR', error.response.data);
        resolve([])
      })
    })
  },
  getCallWaiter: () => {
    return new Promise(resolve => {
      axiosInstance.get('call-waiter-active',).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.log('actions ERROR', error.response.data);
        resolve([])
      })
    })
  },
  dismissWaiterCalled: () => {
    return new Promise(resolve => {
      axiosInstance.post('dismiss-waiter-called',).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.log('actions ERROR', error.response.data);
        resolve([])
      })
    })
  },
}

export default Api
